export default "// extracted by mini-css-extract-plugin\nexport {};";